import React, { } from "react";
import { Link, useLocation } from "react-router-dom";
import AdminRoutes from "../../../routes/AdminRoutes";
import styles from '../index.module.css';
import Logo from '../../../assets/images/brand/lotto_logo.png';
import ToggleIcon from '../../../assets/images/icons/toggle_icon.png';

const Sidebar = ({ isSidebarOpen, closeSidebar }) => {
    const location = useLocation(); // Get the current location
    const slicedRoutes = AdminRoutes.slice(0, 16);

    return (
        <>
            <div className={`${styles.sideBarContainer} ${isSidebarOpen ? styles.showSidebar : styles.hideSidebar
                }`}>
                <div className={styles.sidebarLogo}>
                    <img src={ToggleIcon} className={styles.toggleBtn} alt="toggle" onClick={closeSidebar} />
                    <img src={Logo} alt="Logo" className={styles.logoImage} />
                </div>
                <ul className={styles.sidebarMenu}>
                    {slicedRoutes.map((item, index) => (
                        <li
                            key={index}
                            className={location.pathname === `/admin/${item.path}` ||
                                location.pathname.startsWith(`/admin/${item.path}/`) ? styles.active : ""} // Add 'active' class
                            onClick={closeSidebar}
                        >
                            <Link to={`/admin/${item.path}`} className={styles.linkText}>
                                <img src={location.pathname === `/admin/${item.path}` ||
                                    location.pathname.startsWith(`/admin/${item.path}/`) ? item.icon : item.inactiveIcon}
                                    className={styles.sidebarIcon}
                                    alt="Icon" />
                                <span>{item.name}</span>
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
        </>
    );
};

export default Sidebar;
